import { render } from "./CreateNewSpv.vue?vue&type=template&id=d3b7566a&scoped=true"
import script from "./CreateNewSpv.vue?vue&type=script&lang=js"
export * from "./CreateNewSpv.vue?vue&type=script&lang=js"

import "./CreateNewSpv.vue?vue&type=style&index=0&id=d3b7566a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3b7566a"]])

export default __exports__